(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/containers/wrapper.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/containers/wrapper.js');
'use strict';

const tickets = svs.tickets;
const wrapperStyle = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: 'var(--availableContentHeight)'
};
const Wrapper = _ref => {
  let backgroundStyle = _ref.backgroundStyle,
    children = _ref.children,
    imagePosition = _ref.imagePosition;
  const Background = tickets.next.containers.Background;
  if (typeof Background !== 'function') {
    return React.createElement("div", {
      style: wrapperStyle
    }, children);
  }
  return React.createElement(Background, {
    imagePosition: imagePosition,
    style: backgroundStyle
  }, React.createElement("div", {
    style: wrapperStyle
  }, children));
};
setGlobal('svs.tickets.next.containers.Wrapper', Wrapper);

 })(window);